import { createActionRoute, createSiteRoute } from '@townsquare/router/create-route';

export const followProjectActionRoute = createSiteRoute(
	createActionRoute({
		exact: true,
		name: 'followProjectAction',
		path: '/project/:key/:action(follow|unfollow)',
	}),
);
